import React from 'react';
import { motion } from 'framer-motion';
import { FaCode, FaRocket, FaLightbulb } from 'react-icons/fa';
import './About.css';

const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  const features = [
    {
      icon: <FaCode />,
      title: '.NET Expertise',
      description: 'Specialized in .NET Core, .NET 6+, Blazor, and building scalable backend applications.',
    },
    {
      icon: <FaRocket />,
      title: 'Full Stack Development',
      description: 'Experienced in both backend (.NET) and frontend (Angular, React, Blazor) development.',
    },
    {
      icon: <FaLightbulb />,
      title: 'Problem Solver',
      description: 'Quick to adapt under pressure, with experience in banking systems and real-time data processing.',
    },
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <motion.div
          className="about-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div className="about-text" variants={itemVariants}>
            <h2 className="section-title">About Me</h2>
            <div className="about-description">
              <p>
                I have a strong background in information technology with a focus on backend 
                development, particularly in .NET. I thrive on tackling new challenges and 
                continuously expanding my skill set.
              </p>
              <p>
                My passion for learning drives me to quickly adapt and excel under pressure. 
                With experience in both backend and frontend development, I've worked on 
                various banking projects, integrated third-party services, and managed CI/CD 
                pipelines to enhance efficiency.
              </p>
              <p>
                Currently pursuing my Bachelor's degree in Computer Software Engineering at the 
                Faculty of Information Technologies, I'm always eager to take on new projects 
                and contribute to innovative solutions.
              </p>
            </div>
          </motion.div>

          <motion.div className="about-features" variants={itemVariants}>
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="feature-card"
                variants={itemVariants}
                whileHover={{ y: -10, scale: 1.02 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
